import { Navigate, Outlet } from "react-router";
import { type RoleValue } from "constants/roles";
import { useRoleAnywhere } from "store/session";

// UX guard only — hides role-gated routes/nav from users without the role.
// The real boundary is the backend's `role_access` 403.
export default function RequireRoleRoute({ role }: { role: RoleValue }) {
  const { hasRole } = useRoleAnywhere();
  if (!hasRole(role)) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
